/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";

const dest = createAccessors("hybridspace-teamWorkPlanDashboard", createStore("hybridspace-teamWorkPlanDashboard", {
    pivotState: "summary",
    availableBuildings: [] as string[],
    attendanceInformation: new Map(),
}));
const getPivotState: () => string = dest.getPivotState;
const setPivotState: (newValue: string) => void = dest.setPivotState;
const getAvailableBuildings: () => string[] = dest.getAvailableBuildings;
const setAvailableBuildings: (newValue: string[]) => void = dest.setAvailableBuildings;
const getAttendanceInformation: () => Map<any, any> = dest.getAttendanceInformation;
const setAttendanceInformation: (newValue: Map<any, any>) => void = dest.setAttendanceInformation;

export { getPivotState, setPivotState, getAvailableBuildings, setAvailableBuildings, getAttendanceInformation, setAttendanceInformation, };
